export const SIGNIN = 'signin';
export const SIGNUP = 'signup';
export const CANCEL_LOGIN = 'cancel_login';
export const USER_DETAILS = 'user_details';
export const SWITCH_CARD = 'switch_card';
export const SKIP_USER_DETAILS = 'skip_user_details';
export const HEADER_LIST_ITEMS = {
  'Home': 'home',
  'Just For you': 'just_for_you',
  'Stay': 'compare_and_stay',
  'Flight': 'compare_and_fly',
  'Bus': 'bus',
  'Trains': 'train',
  'Rewards Catalogue': 'rewards',
  'Miles Transfer': 'miles_transfer',
  "Today's Deal": 'steal_deals',
  'Shop': 'shop',
  'zoomcar': 'car_rentals',
  'Holiday Packages': 'holiday_package',
  'Points to Cash': 'points_to_cash',
  'Instant Vouchers': 'instant_vouchers',
  'Savings Calculator': 'savings_calculator',
  'Accelerated Earn Rules': 'accelerated_earn_rules',
  'Milestone': 'milestone'
};

export const BOOKING_TYPES = {
  'flight': 'flight',
  'bus': 'bus',
  'trains': 'train',
  'stay': 'hotel',
  'rewards catalogue': 'rewards',
  'miles transfer': 'miles_transfer'
};
